(() => {
  const STORAGE_KEY = "apostle-radio-open";

  function initializeApostleRadio(root) {
    if (!root || root.dataset.initialized === "true") return;

    const trigger = root.querySelector("[data-radio-trigger]");
    const panel = root.querySelector("[data-radio-panel]");
    const closeButton = root.querySelector("[data-radio-close]");

    if (!trigger || !panel || !closeButton) return;

    root.dataset.initialized = "true";

    const setOpen = (open) => {
      panel.hidden = !open;
      trigger.setAttribute("aria-expanded", String(open));

      try {
        sessionStorage.setItem(STORAGE_KEY, String(open));
      } catch (error) {
        console.warn("Apostle Radio preference could not be saved.", error);
      }
    };

    trigger.addEventListener("click", () => {
      const currentlyOpen =
        trigger.getAttribute("aria-expanded") === "true";

      setOpen(!currentlyOpen);
    });

    closeButton.addEventListener("click", () => {
      setOpen(false);
      trigger.focus();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !panel.hidden) {
        setOpen(false);
        trigger.focus();
      }
    });

    try {
      const savedState = sessionStorage.getItem(STORAGE_KEY);

      if (savedState === "true") {
        setOpen(true);
      }
    } catch (error) {
      console.warn("Apostle Radio preference could not be restored.", error);
    }
  }

  function initializeAllRadios(container = document) {
    container
      .querySelectorAll("[data-apostle-radio]")
      .forEach(initializeApostleRadio);
  }

  document.addEventListener("DOMContentLoaded", () => {
    initializeAllRadios();
  });

  document.addEventListener("shopify:section:load", (event) => {
    initializeAllRadios(event.target);
  });
})();